import React, { PropTypes } from 'react';
import { Icon } from '@shoflo-rundown/polymer.legacy';

/**
 * Activity Feed Restore Button
 */
const RestoreButton = (props) => {
  return (
    <div
      onClick={props.onClick} // eslint-disable-line react/prop-types
      className="af-list-item-undo-icon"
    >
      <Icon name="undo" />
    </div>
  );
};

RestoreButton.propsTypes = {
  onClick: PropTypes.func,
};

export default RestoreButton;
